<template>
  <ul
    v-if="$store.getters.isAuthorized"
    class="header-buttons"
  >
    <li>
      <router-link
        to="/logout"
        tag="button"
        class="btn btn--ghost d-lg-none"
      >
        Sign Out
      </router-link>
    </li>
    <li
      class="d-none d-lg-inline-block user-menu"
    >
      <div>
        <font-awesome-icon
          :icon="['fas', 'user-circle']"
          class="icon alt"
        />
        <span>
          <font-awesome-icon
            :icon="['fas', 'chevron-down']"
            class="icon alt"
          />
        </span>
      </div>
      <ul>
        <li>
          <router-link to="/account">
            My Account
          </router-link>
        </li>
        <li>
          <router-link to="/updatePassword">
            Update Password
          </router-link>
        </li>
        <li
          v-if="
            ($store.getters.isAdminUser)
              && $store.getters.currentUser.allowed_programmatic_access"
        >
          <router-link to="/programmaticAccess">
            Programmatic Access
          </router-link>
        </li>
        <li
          v-if="
            ($store.getters.isAdminUser)
              && $store.getters.currentUser.allowed_programmatic_access"
        >
          <router-link to="/apiDocumentation">
            API Documentation
          </router-link>
        </li>
        <li>
          <router-link to="/logout">
            Sign Out
          </router-link>
        </li>
      </ul>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'HeaderButtons',
};
</script>

<style lang="scss" scoped>
ul {
  margin-bottom: 0;
  list-style-type: none;

  li {
    display: inline-block;

    &:first-of-type {
      margin-right: 5px;
    }

    button {
      position: relative;
      top: -2px;
    }
  }
}

.header-buttons {
  padding: 0;
}

.header__nav ul li {
  line-height: normal;
}

.user-menu {
  position: relative;
  margin-top: 14px;

  div {
    display: inline-block;
    color: $blue;
    font-size: 25px;
    vertical-align: top;

    span {
      display: inline-block;
      margin-left: 8px;
      font-size: 10px;
      vertical-align: middle;
    }
  }

  ul {
    display: none;
  }

  &:hover {
    div {
      color: lighten($blue, 5%);

      span {
        color: rgba(0, 0, 0, 0.67);
      }
    }

    ul {
      @include border-radius($border-radius);

      position: absolute;
      right: 0;
      display: block;
      padding: 0;
      background: white;
      border: solid 1px #ddd;
      box-shadow:
        0 10px 20px rgba(0, 0, 0, 0.19),
        0 6px 6px rgba(0, 0, 0, 0.23);

      li {
        display: block;
        width: 100%;
        padding: 0;

        a {
          display: block;
          width: 100%;
          padding: 5px 20px;
          color: rgba(0, 0, 0, 0.67);
          white-space: nowrap;

          &:hover {
            color: $blue;
            background: #fafafa;
          }
        }
      }
    }
  }
}
</style>
